import React from "react";
import "./WhatsAppIcon.css"; // Import the provided CSS file
import { FaWhatsapp } from "react-icons/fa";
import axios from "axios";


const WhatsAppIcon = () => {
    const [number, setNumber] = React.useState("")

    const fetchNumber = async () => {
        try {
            const response = await axios.get("https://api.glyphqai.com/api/get-link/whatsapp_url");
            setNumber(response.data.socialLinks.value);
            console.log(response.data.socialLinks.value);
            
        } catch (err) {
            console.log("Failed to fetch resources", err);
        }
    }

    React.useEffect(() => {
        fetchNumber();
    }, [])

    return (
        <div className="whatsapp-icon rounded-4">
            <a
                href={`https://wa.me/${number || '923001234567'}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-white"
            >
                <FaWhatsapp className="whatsapicon" />
                {/* <i className="fa-brands fa-whatsapp" ></i> */}
            </a>
        </div >
    );
};

export default WhatsAppIcon;
